/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popTask.vue?vue&type=template&id=7ca7b31a&scoped=true"
import script from "./popTask.vue?vue&type=script&lang=js"
export * from "./popTask.vue?vue&type=script&lang=js"
import style0 from "./popTask.vue?vue&type=style&index=0&id=7ca7b31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca7b31a",
  null
  
)

export default component.exports